/**
 * @class DownloadingFile
 */
export default class DownloadingFile {
    /**
     * @param {Number} id
     * @param {String} fileName
     * @param {String} filePath
     * @param {Number} totalLength
     * @param {Number} downloadedLength
     */
    constructor(id, fileName, filePath, totalLength, downloadedLength) {
        this._id = id;
        this._fileName = fileName;
        this._filePath = filePath;
        this._totalLength = totalLength;
        this._downloadedLength = downloadedLength;
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get fileName() {
        return this._fileName;
    }

    /**
     * @param {String} fileName
     */
    set fileName(fileName) {
        this._fileName = fileName;
    }

    /**
     * @return {String}
     */
    get filePath() {
        return this._filePath;
    }

    /**
     * @param {String} filePath
     */
    set filePath(filePath) {
        this._filePath = filePath;
    }

    /**
     * @return {Number}
     */
    get totalLength() {
        return this._totalLength;
    }

    /**
     * @param {Number} totalLength
     */
    set totalLength(totalLength) {
        this._totalLength = totalLength;
    }

    /**
     * @return {Number}
     */
    get downloadedLength() {
        return this._downloadedLength;
    }

    /**
     * @param {Number} downloadedLength
     */
    set downloadedLength(downloadedLength) {
        this._downloadedLength = downloadedLength;
    }

    updateDownloadedLength(downloadedLength) {
        return new DownloadingFile(this._id, this._fileName, this._filePath, this._totalLength, downloadedLength);
    }
}
